import $ from 'jquery'
import { Modal } from 'bootstrap'
import Cookies from 'js-cookie'
import {liteClient} from "algoliasearch/lite";
import {algoliaApiKey, algoliaAppId, citiesSearchIndex, jobsSearchSuggestionsIndex} from "./variables";
import {autocomplete, getAlgoliaResults} from "@algolia/autocomplete-js";
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import {Alert} from "./functions";
import {jobsSearch} from "./pages/jobs";

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const object = vnObject
const body = document.body

const setThemeVars = () => {
  const documentWidth = document.documentElement.clientWidth
  const width = Math.abs(window.innerWidth - documentWidth)
  body.style.setProperty('--scrollbar-width', `${width}px`)

  const mainContainer = document.querySelector('#colophon > .container')
  const mainContainerWidth = mainContainer.clientWidth

  const col = document.querySelector('.vn-col-sizer')
  const colWidth = col.clientWidth

  const headerContainer = document.querySelector('.site-header')
  const headerContainerHeight = headerContainer.clientHeight

  body.style.setProperty(
    '--space-width',
    `${(documentWidth - mainContainerWidth) / 2 + 20}px`
  )

  body.style.setProperty('--container-width', `${mainContainerWidth}px`)
  body.style.setProperty('--main-width', `${documentWidth}px`)
  body.style.setProperty('--col-width', `${colWidth}px`)
  body.style.setProperty('--header-height', `${headerContainerHeight}px`)
}

setThemeVars()
window.addEventListener('load', setThemeVars)
window.addEventListener('resize', setThemeVars)

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  if($(this).attr('data-url').length > 0 ) {
    window.location.href = $(this).attr('data-url')
  }
})

const allModals = document.querySelectorAll('[data-bs-toggle="modal"]')
if (allModals.length) {
  ;[...allModals].map((modal) => {
    new Modal(modal)
  })
}

$('.vn-excerpt__more').on('click', function () {
  const button = $(this)
  const button_parent = button.parents('.vn-excerpt')

  if (button_parent.hasClass('vn-excerpt--active')) {
    button.html(object.readMore)
  } else {
    button.html(object.readLess)
  }

  button_parent.toggleClass('vn-excerpt--active')
})

$('.js-close-event').on( 'click', function (e) {
  e.preventDefault()
  $('.js-next-event').fadeOut()
  $('.event-active').removeClass('event-active');
  Cookies.set('nextEvent', 1)
})

$(document).ready(function() {
  if ($('.js-next-event').length) {
    $('.site-main').addClass('event-active');
  }
});

const toc = $('.vn-toc')
if (toc.length) {
  const headings = $('.entry-content h2')
  if (headings.length) {
    const list = toc.find('ul')
    headings.map((index, heading) => {
      if (heading) {
        heading.id = `toc-${index}`
        list.append(`<li><a class="vn-toc-link" href="#toc-${index}">${heading.innerText}</a></li>`)
      }
    })
  }
}

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top
  var elementBottom = elementTop + $(this).outerHeight()

  var viewportTop = $(window).scrollTop()
  var viewportBottom = viewportTop + $(window).height()

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

setVisibleToc()
$(window).scroll(function() {
  setVisibleToc()
});

function setVisibleToc() {
  $('.vn-toc-link').each(function() {
    var targetId = $(this).attr('href')
    var targetElement = $(targetId)

    if (targetElement.isInViewport()) {
      $(this).addClass('is-active')
    }
    else {
      $(this).removeClass('is-active')
    }
  })
}

$('.vn-btn-tel').hover(
    function() {
      var dataNumber = $(this).data('number');
      $(this).html(dataNumber);
    },
    function() {
      if ( ! $(this).hasClass('clicked') ) {
        var dataContent = $(this).data('content');
        $(this).html(dataContent);
      }
    }
);

$('.vn-btn-tel').click(function() {
  var dataNumber = $(this).data('number');
  $(this).html(dataNumber);
  $(this).addClass('clicked');
});

const searchClient = liteClient(algoliaAppId, algoliaApiKey)
let cityModalSearch

var check = $('.modal-cities-search-handler')
const checkEl = document.querySelector('.modal-cities-search-handler')
if ( checkEl ) {
  cityModalSearch = autocomplete({
    container: '.modal-cities-search-handler',
    detachedMediaQuery: 'none',
    placeholder: __('Montpellier, Aix-en-Provence...', 'vn'),
    getSources() {
      return [{
        sourceId: 'cities',
        getItems({ query }) {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: citiesSearchIndex,
                query,
              },
            ],
          });
        },
        templates: {
          item({ item }) {
            var postalCode = item.codesPostaux.substring(0, 2)
            return `${item.nom} ( ${postalCode} )`;
          },
        },
        onSelect: function (event) {
          let latLng = parseFloat(event.item.latitude) + ',' + parseFloat(event.item.longitude);
          var postalCode = event.item.codesPostaux.substring(0, 2)
          event.setQuery( event.item.nom + ' ( ' + postalCode + ' )' );
          $('.js-city').val( event.item.nom + ' ( ' + postalCode + ' )' )
          $('.js-latlng').val( latLng )
        },
      }];
    },
  });
}


const querySuggestionsPlugin = createQuerySuggestionsPlugin({
  searchClient,
  indexName: jobsSearchSuggestionsIndex,
  transformSource({ source }) {
    return {
      ...source,
      templates: {
        item(params) {
          const { item, html } = params;

          return html`<div class="algolia-suggest-item js-what-suggestion-item">
            ${source.templates.item(params).props.children}
          </div>`;
        },
      },
    };
  },
});

let whatModalSearch

var whatCheck = $('.modal-what-search-handler')
const whatCheckEl = document.querySelector('.modal-what-search-handler')
if ( whatCheckEl ) {
  whatModalSearch = autocomplete({
    container: '.modal-what-search-handler',
    detachedMediaQuery: 'none',
    plugins: [querySuggestionsPlugin],
    openOnFocus: true,
    placeholder: __('Building, technician...', 'vn'),
    onStateChange({ prevState, state }) {
      if ( state.query != undefined && state.query.length == 0 ) {
        $('.js-what').val( '' )
      }
      else if ( state.query != undefined ) {
        $('.js-what').val( state.query )
      }
    },
  });
}

const jobSearchForm = $('.js-search-job')
$('.js-search-modal-job').on('click', function () {
  jobSearchForm.trigger('submit')
})

jobSearchForm.on('submit', function (e) {
  e.preventDefault()
  e.stopPropagation()

  const formData = new FormData(jobSearchForm[0])
  formData.append('action', 'vn_search_job')
  formData.append('nonce', object.nonce)

  const $form = $(this)
  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    data: formData,
    beforeSend: () => {
      $form.addClass('sending')
    },
    processData: false,
    contentType: false,
    success: (res) => {
      $form.removeClass('sending')

      if (res.success && res.data.redirect) {
        window.location = res.data.redirect
      }
    },
  })
})

$('a[href="#cookies"]').on('click', (e) => {
  e.preventDefault()
  window.openAxeptioCookies()
})
